import { render, staticRenderFns } from "./PublishingContractsWorksEditPanel.vue?vue&type=template&id=113b18d8"
import script from "./PublishingContractsWorksEditPanel.vue?vue&type=script&lang=js"
export * from "./PublishingContractsWorksEditPanel.vue?vue&type=script&lang=js"
import style0 from "./PublishingContractsWorksEditPanel.vue?vue&type=style&index=0&id=113b18d8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports